export const starters = [{
  id: 'welcome',
  name: 'Welcome',
  subject: 'Welcome, {{customer.name}}',
  format: 'html',
  body: '<h2>Welcome, {{customer.name}} 👋</h2><p>Thank you for choosing {{company.name}}. We are glad to help.</p><p>{{welcome.next_step}}</p><p>Best wishes,<br>{{sender.name}}</p>'
}, {
  id: 'payment',
  name: 'Payment reminder',
  subject: 'Reminder: invoice {{invoice.number}}',
  format: 'html',
  body: '<h2>A friendly payment reminder</h2><p>Hello {{customer.name}},</p><p>Invoice <strong>{{invoice.number}}</strong> for <strong>{{invoice.amount}}</strong> is due on {{invoice.due_date}}.</p><p>Please see the attached invoice. If you have already paid, thank you.</p><p>{{sender.name}}</p>'
}, {
  id: 'meeting',
  name: 'Meeting confirmation',
  subject: 'Your meeting on {{meeting.date}}',
  format: 'html',
  body: '<h2>Let’s meet, {{customer.name}}</h2><p>Your meeting is scheduled for <strong>{{meeting.date}}</strong> at {{meeting.time}} ({{meeting.timezone}}).</p><p>Join here: {{meeting.url}}</p><p>{{meeting.agenda}}</p><p>{{sender.name}}</p>'
}];
export function variableKeys(subject, body) {
  return [...new Set([...`${subject} ${body}`.matchAll(/\{\{\s*([a-zA-Z][a-zA-Z0-9_.]{0,511})\s*\}\}/g)].map(m => m[1]))];
}
